module.exports = __webpack_public_path__ + "img/exitWhite.8963a0a8.svg";